import {Brick, ErrorFlow, Query, registerBrick, Transaction} from 'olympe';
import PurchaseRequestDM from '../../models/cloudobjects/PurchaseRequestDM';
import {PurchaseRequest} from '../../models/PurchaseRequest';

/**
 * This brick updates a Purchase Request (Cloud Object) based on a PR json
 */
export default class UpdatePurchaseRequestFromJSON extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRJson
     * @param {PurchaseRequestDM | string} purchaseRequest
     * @param {function()} forwardEvent
     * @param {function(*)} setPurchaseRequest
     * @param {function(*)} setErrorFlow
     */
    async update($, [pRJson, purchaseRequest], [forwardEvent, setPurchaseRequest, setErrorFlow]) {
        let status;
        if (purchaseRequest instanceof PurchaseRequestDM) {
            status = purchaseRequest.getStatus();
        } else {
            const pr = await Query.fromTag(purchaseRequest, PurchaseRequestDM).execute();
            status = pr.getFirst().getStatus();
        }
        if (status === PurchaseRequest.statuses.submitted) {
            setErrorFlow(ErrorFlow.create('Cannot update a submitted request.', 1));
            return;
        }

        const tx = new Transaction();
        try {
            PurchaseRequestDM.updatePurchaseRequestFromJson(pRJson, purchaseRequest, tx);
        } catch (e) {
            return (ErrorFlow.create(`Impossible to update a PR from JSON: ${e}`, 1));
        }

        tx.execute()
            .then(() => {
                setPurchaseRequest(purchaseRequest);
                forwardEvent();
            })
            .catch((error) => setErrorFlow(ErrorFlow.create(`Impossible to update a PR from JSON: ${error}`, 1)));
    }
}

registerBrick('0196b3d40561f2687a87', UpdatePurchaseRequestFromJSON);
